@if (open()) {
  <div class="fixed inset-0 z-[60] flex items-end justify-center p-0 sm:items-center sm:p-4" (keydown)="onKeydown($event)">
    <div class="absolute inset-0 bg-black/70" (click)="close()" aria-hidden="true"></div>
    <section role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId"
      cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
      class="relative flex max-h-[85vh] w-full flex-col rounded-t-2xl border border-white/10 bg-[#121212]/95 pb-[env(safe-area-inset-bottom,0px)] text-white shadow-2xl sm:rounded-2xl sm:pb-0"
      [class]="widthClass()"
      [class.backdrop-blur-md]="!settings.reduceBlur()">
      <header class="flex items-center gap-2 px-5 pb-2 pt-4">
        <h2 [id]="titleId" class="min-w-0 flex-1 truncate text-lg font-semibold" [title]="title()">{{ title() }}</h2>
        <button type="button" (click)="close()" aria-label="Close"
          class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full text-gray-400 hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400">
          <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </header>
      <div class="min-h-0 flex-1 overflow-y-auto overscroll-contain px-5 pb-4">
        <ng-content />
      </div>
      <ng-content select="[dialogFooter]" />
    </section>
  </div>
}
